
import { supertagTok } from '@/constants/supertag';

const MSG_TYPE_LIST = [
  300,301,302,303,304,310,311,312,313,314,315,316,317,318,319,320,
  321,322,323,324,325,326,327,328,329,330,331,332,333,334,335,336,
  337,338,339,340,10,11,12,13,35,36,37
];

export const TagIconConfig = {
  /**
   * Normalize the tag to support both snake_case (API) and camelCase
   * @param {Object} tag - Tag object
   * @returns {Object} Normalized tag
   */
  normalizeTag(tag) {
    return {
      appTok: tag.appTok || tag.app_tok,
      source: tag.source || tag.positionSource,
      msgType: tag.msgType,
      locationTime: tag.locationTime,
      latitudeTime: tag.latitudeTime || tag.latitude_time,
      isLeashTag: tag.isLeashTag
    };
  },

  /**
   * Get the complete icon configuration for a tag
   * @param {Object} tag - Tag object with normalized properties
   * @returns {Object} Icon configuration { type, icon, title, imageSrc, class }
   */
  getConfig(tag) {
    if (!tag) return this.getDefaultConfig();

    const normalized = this.normalizeTag(tag);

    // Leash Tag tiene prioridad
    if (this.isLeashTag(normalized)) {
      return {
        type: 'icon',
        icon: 'mdi-office-building-marker',
        title: 'assets-in-leashed-tag',
        class: normalized.source ? normalized.source.toLowerCase() : ''
      };
    }

    // SuperTag outdoor
    if (!this.isIndoor(normalized) && !this.stInIndoor(normalized) && normalized.source) {
      const imageSrc = this.getImageSource(normalized.source);
      return {
        type: 'image',
        imageSrc,
        title: 'assets-is-supertag',
        width: '10',
        height: '16'
      };
    }

    // Tag indoor normal
    if (this.isIndoor(normalized)) {
      return {
        type: 'icon',
        icon: 'mdi-office-building-marker',
        title: 'assets-is-indoor'
      };
    }

    // SuperTag convertido a indoor sin beacon
    if (this.stInIndoor(normalized) && !this.hasBeaconSource(normalized)) {
      return {
        type: 'icon',
        icon: 'mdi-map-marker-off',
        title: 'assets-st-into-tag'
      };
    }

    // SuperTag convertido a indoor con beacon
    if (this.stInIndoor(normalized) && this.hasBeaconSource(normalized)) {
      return {
        type: 'image',
        imageSrc: this.getImageSource('beacon'),
        title: 'assets-is-supertag',
        width: '10',
        height: '16'
      };
    }

    return this.getDefaultConfig();
  },

  /**
   * Configuración por defecto para tags sin clasificación
   */
  getDefaultConfig() {
    return {
      type: 'icon',
      icon: 'mdi-map-marker',
      title: 'assets-unknown-tag'
    };
  },

  
  getImageSource(source) {
    const sources = {
      gps: require('@/assets/img/map/pin_gps.png'),
      wifi: require('@/assets/img/map/pin_wifi.png'),
      wifi_override: require('@/assets/img/map/pin_wifi.png'),
      cellid: require('@/assets/img/map/pin_cell.png'),
      beacon: require('@/assets/img/map/pin_location.png'),
      loc0: require('@/assets/img/map/pin_location.png'),
      heartbeat: require('@/assets/img/map/pin_hb.png'),
      hb: require('@/assets/img/map/pin_hb.png'),
      default: require('@/assets/img/map/pin_gps.png')
    };
    return sources[source?.toLowerCase()] || sources.gps;
  },

  isLeashTag(tag) {
    if (typeof tag.isLeashTag === 'boolean') return tag.isLeashTag;
    const msgType = parseInt(tag.msgType, 10);
    return Number.isFinite(msgType) ? MSG_TYPE_LIST.includes(msgType) : false;
  },

  isIndoor(tag) {
    return !supertagTok.includes(tag.appTok);
  },

  stInIndoor(tag) {
    if (supertagTok.includes(tag.appTok)) {
      if (tag.locationTime && tag.latitudeTime) {
        return tag.locationTime > tag.latitudeTime;
      }
      return !!tag.locationTime;
    }
    return false;
  },

  hasBeaconSource(tag) {
    return !!(tag.source && tag.source.toLowerCase() === 'beacon');
  }
};
